export default {
    deepClone(obj) {
        let _obj = JSON.stringify(obj);
        return JSON.parse(_obj);
    }
}